import {
  STORE_KEY_ACCOUNT,
  evalCondition,
  notifyParent,
  storeGet,
} from 'mailup-react-helpers'

export const offerType = {
  Undefined: 0,
  Banda: 1,
  Frequenza: 2,
  StarterEdition: 3,
  PlusEdition: 4,
  EnterpriseEdition: 5,
  SoloSMS: 6,
  PremiumEdition: 7,
  LightEdition: 8
}

export const canUseMshop = (): boolean => {
  return evalCondition(
    'NOT c:IsRetailer AND uo:GEST AND NOT c:IsDeveloper AND NOT co:TURNOFFMSHOP AND NOT c:IsOfferFrequenza'
  )
}

export const mshopBuy = (): void => {
  notifyParent('redirectMainFrame', [`mshop_Redirector.aspx?t=mshopem`])
}

export const isEcommerceVisible = (): boolean => {
  const {
    IsRetailer,
    IsDeveloper,
  }: {
    IsRetailer: boolean
    IsDeveloper: boolean
  } = storeGet(STORE_KEY_ACCOUNT)

  const bUserGest: boolean = evalCondition('uo:GEST')
  const bConsoleMshop: boolean = evalCondition('co:TURNOFFMSHOP')

  return !IsRetailer && bUserGest && !IsDeveloper && !bConsoleMshop
}

export const canBuyEngagementFilters = (): boolean => {
  const standardEcomm = isEcommerceVisible()
  const { IdOffer } = storeGet(STORE_KEY_ACCOUNT)

  //  Solo SMS, Starter, Plus, Premium ed enterprise possono acquistare Filtri & Report da MShop
  const validEditions = [
    offerType.Frequenza,
    offerType.SoloSMS,
    offerType.StarterEdition,
    offerType.PlusEdition,
    offerType.PremiumEdition,
    offerType.EnterpriseEdition,
    offerType.LightEdition
  ]

  return standardEcomm && validEditions.includes(IdOffer)
}
